import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { IoFunnel } from "react-icons/io5";

import { Row, Col } from "react-bootstrap";

import ContractService from "../../services/contractService";

import HeaderWrapper from "../common/HeaderWrapper";
import FiltersComponent from "../common/FiltersComponent";

import ContractList from "./ContractList";

const ContractPage = ({ history, isMobile }) => {
  const [total, setTotal] = useState(0);
  const [contracts, setContracts] = useState([]);
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState(
    localStorage.getItem("contract-filters")
      ? JSON.parse(localStorage.getItem("contract-filters"))
      : {
          contract_status: null,
          customer: null
        }
  );
  const [defaultPageSize, setPageSize] = useState(
    localStorage.getItem("DEFAULT_PAGE_SIZE_CONTRACT_LIST")
      ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_CONTRACT_LIST"))
      : 10
  );
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sorted, setSorted] = useState([{ id: "name", desc: true }]);
  const [pages, setPages] = useState(0);

  const auth = useSelector((state) => state.reducers.auth);

  useEffect(() => {
    const fetchContracts = async () => {
      setLoading(true);
      const newSorted =
        sorted &&
        Array.isArray(sorted) &&
        sorted.reduce((acc, curr) => {
          acc[`sort.${curr.id}`] = curr.desc ? 1 : -1;
          return acc;
        }, {});
      const parsedFilters = {
        page,
        pageSize: defaultPageSize,
        contract_status:
          Array.isArray(filters.contract_status) &&
          filters.contract_status.length > 0
            ? filters.contract_status.map((f) => f.value)
            : null,
        customer:
          Array.isArray(filters.customer) && filters.customer.length > 0
            ? filters.customer.map((f) => f.value)
            : null,
        contract_type:
          Array.isArray(filters.contract_type) &&
          filters.contract_type.length > 0
            ? filters.contract_type.map((f) => f.value)
            : null,
        salesperson:
          Array.isArray(filters.salesperson) && filters.salesperson.length > 0
            ? filters.salesperson.map((f) => f.value)
            : null
      };
      const {
        contracts: data,
        total: count,
        pages: totalPages
      } = await ContractService.loadContracts({
        filtered: parsedFilters,
        sorted: newSorted
      });
      setLoading(false);
      setContracts(data);
      setTotal(count);
      setPages(totalPages);
    };
    fetchContracts();
  }, [defaultPageSize, filters, page, sorted]);

  const onPageSizeChange = (pageSize) => {
    setPageSize(pageSize);
    localStorage.setItem("DEFAULT_PAGE_SIZE_CONTRACT_LIST", pageSize);
  };

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const onSortedChange = (newSorted) => {
    setSorted(newSorted);
  };

  const onClickAdd = () => {
    history.push("/app/contracts/add");
  };

  const onClickView = (id) => {
    history.push(`/app/contracts/${id}`);
  };

  const handleChangeFilters = (field, input) => {
    setFilters((prevState) => {
      const newFilters = {
        ...prevState,
        [field]: Array.isArray(input) ? input : input.value
      };
      localStorage.setItem("contract-filters", JSON.stringify(newFilters));
      return newFilters;
    });
  };

  const resetFilters = () => {
    setFilters({
      contract_status: null,
      customer: null,
      contract_type: null,
      salesperson: null
    });
    localStorage.removeItem("contract-filters");
  };

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: `Contracts (${total} contracts)` }]}
        // only allow add if billing admin, ceo, or admin
        onClickAdd={
          (auth.maxRole === 4000 || auth.maxRole >= 8000) && onClickAdd
        }
        onClickAction={[
          {
            action: () => setOpen((prevState) => !prevState),
            icon: <IoFunnel />
          }
        ]}
        isMobile={isMobile}
      />
      <Row style={{ margin: 0 }}>
        <Col md={12}>
          <FiltersComponent
            open={open}
            filters={filters}
            onChangeFilters={handleChangeFilters}
            onReset={resetFilters}
            fields={[
              "Contract Status",
              "Customer",
              "Contract Type",
              "Salesperson"
            ]}
          />
        </Col>
      </Row>
      <div className="content-wrapper">
        <ContractList
          manual
          onPageSizeChange={onPageSizeChange}
          onPageChange={onPageChange}
          onSortedChange={onSortedChange}
          sorted={sorted}
          page={page}
          pageSize={defaultPageSize}
          contracts={contracts}
          loading={loading}
          isMobile={isMobile}
          onClickView={onClickView}
          auth={auth}
          total={total}
          pages={pages}
        />
      </div>
    </React.Fragment>
  );
};

ContractPage.propTypes = {
  isMobile: PropTypes.bool,
  history: PropTypes.object
};

export default ContractPage;
